var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.224,
    height: 20,
    viewBox: "0 0 17.224 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.773,14.564h3.561l-3.748-3.681v3.494A.187.187,0,0,0,416.773,14.564Zm0,0",
    transform: "translate(-403.457 -10.542)",
    fill: "#697384"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.648,5.185A1.361,1.361,0,0,1,9.287,3.827V0H-.477A2.191,2.191,0,0,0-2.668,2.186V17.814A2.191,2.191,0,0,0-.477,20H12.365a2.191,2.191,0,0,0,2.191-2.186V5.185ZM9.306,17.152H1.743a.586.586,0,1,1,0-1.172H9.306a.586.586,0,1,1,0,1.172Zm-8.15-4.925a.587.587,0,0,1,.587-.586H8.492a.586.586,0,1,1,0,1.172H1.743A.587.587,0,0,1,1.156,12.227ZM10.02,8.473H1.743a.586.586,0,1,1,0-1.172H10.02a.586.586,0,1,1,0,1.172Zm0,0",
    transform: "translate(2.668)",
    fill: "#697384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.c85ed33fe5e99ccb484fff4d6c1a6060.svg";
export { ForwardRef as ReactComponent };